<template>
    <div class="record-status-bar">
        <div class="row no-gutters px-3 py-1 bg-secondary text-white"
             v-if="!service || service.approved === false">
            <div class="col d-flex align-items-center">
                <h5 class="font-weight-bold mb-0">
                    <font-awesome-icon class="mr-1"
                                       icon="spinner">
                    </font-awesome-icon>
                    待審核
                </h5>
            </div>
            <div class="text-center"
                 v-if="['vending-admin'].includes(userRole)">
                <button class="btn btn-sm btn-success lighten shadow-sm"
                        v-bind:class="{ 'btn-loading': isLoading }"
                        v-on:click="approveService">
                    批準服務
                </button>
            </div>
        </div>

        <template v-else-if="Array.isArray(service.editsPending) && service.editsPending.length > 0">
            <div class="row no-gutters px-3 py-1 bg-warning text-dark">
                <div class="col d-flex align-items-center">
                    <h5 class="font-weight-bold mb-0">

                        編輯等待審核
                    </h5>
                </div>
                <div class="text-center"
                     v-if="['vending-admin'].includes(userRole)">
                    <button class="btn btn-sm btn-warning shadow-sm"
                            v-on:click="isModalReevaluateOpened = true">
                        確認編輯
                    </button>
                </div>
            </div>
        </template>

        <template v-else>
            <div class="row no-gutters px-3 py-1 bg-success text-white">
                <div class="col d-flex align-items-center">
                    <h5 class="font-weight-bold mb-0">
                        <font-awesome-icon class="mr-1"
                                           icon="clipboard-check">
                        </font-awesome-icon>
                        已獲批準
                    </h5>
                </div>
                <div class="text-center"
                     v-if="['vending-admin'].includes(userRole)">
                    <button class="btn btn-sm btn-danger shadow-sm"
                            v-on:click="disapproveService">
                        取消批準
                    </button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        name: "ServiceStatusBar",
        components: {

        },
        props: {
            service: {
                type: Object,
                required: true,
            },

            waterContent: {
                type: Number,
            },
        },
        data () {
            return {
                isLoading: false,
            };
        },
        computed: {
            userRole () {
                return this.$store.state.user.user.role;
            },
        },
        methods: {
            async approveService () {
                this.isLoading = true;
                const payload = {
                    _id: this.service._id,
                    approved: true,
                };

                try {
                    await this.$store.dispatch(
                        "data/editService",
                        payload
                    );
                } catch (e) {
                    console.error(e);
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
            },

            async disapproveService () {
                this.isLoading = true;
                const payload = {
                    _id: this.service._id,
                    approved: false,
                };

                try {
                    await this.$store.dispatch(
                        "data/editService",
                        payload
                    );
                } catch (e) {
                    console.error(e);
                    this.isLoading = false;
                    return;
                }
                this.isLoading = false;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .record-status-bar {
        .bg-success,
        .btn-success {
            &.lighten {
                background-color: #34ce57 !important;
            }

            &.darken {
                background-color: #1e7e35 !important;
            }
        }

        .bg-danger {
            &.darken {
                background-color: #bd2130 !important;
            }
        }
    }
</style>
